import type { IconData } from '@stacksjs/iconify-core'

export const sitemapF: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 12.858h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m6-12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m6 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2\"/><path d=\"M9 9.858v-2h2v4H6a1 1 0 0 0-1 1v.935H3v-.935a3 3 0 0 1 3-3z\"/><path d=\"M10 11.858v-2h4a3 3 0 0 1 3 3v1.02h-2v-1.02a1 1 0 0 0-1-1z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default sitemapF
